import React, { useState } from "react";
import PaulImg from "../../images/Staff/Paul.png";
import ChloeImg from "../../images/Staff/ChloeCarzis.png";
import JuMari from "../../images/Staff/Ju-MariBishop.png";
import TakalaniImg from "../../images/Staff/TakalaniNd.png";
import TrustImg from "../../images/Staff/TrustNcube.png";
import SuneImg from "../../images/Staff/Sune.png";
import AbongileImg from "../../images/Staff/Abongile.png";
import JJImg from "../../images/Staff/JJGrobler.png";
import MarkImg from "../../images/Staff/MarkBhunu.png";
import TidimaImg from "../../images/Staff/TidimaMakgoka.png";
import ThaboImg from "../../images/Staff/ThaboSeakamela.png";
import LuckyImg from "../../images/Staff/LuckyManganye.png";
import AneImg from "../../images/Staff/AnéMostert.png";
import classes from "../../components/AboutUs.module.css";
import ThatoImg from "../../images/Staff/Thato.jpeg";
import KamogeloImg from "../../images/Staff/Kamogelo.jpeg";
import ThabisoImg from "../../images/Staff/Thabiso.jpeg";
import Mariana from "../../images/Staff/Mariana.jpeg";

const Teamcards = () => {
  const [person, setPerson] = useState([
    {
      name: "Paul Merwe",
      title: "Managing Director",
      img: PaulImg,
      id: 1,
    },
    {
      name: "Chloë Carzis",
      title: "Finance Manager",
      img: ChloeImg,
      id: 2,
    },

    {
      name: "Takalani Ndou",
      title: "Client Consultant",
      img: TakalaniImg,
      id: 4,
    },
    {
      name: "Trust Ncube",
      title: "Client Consultant",
      img: TrustImg,
      id: 5,
    },
    {
      name: "Suné van Rooyen",
      title: "Marketing Manager",
      img: SuneImg,
      id: 6,
    },

    {
      name: "Ané Mostert",
      title: "Jnr. Business Analyst/ Marketer",
      img: AneImg,
      id: 13,
    },
    {
      name: "Abongile Bungane",
      title: "Client Consultant",
      img: AbongileImg,
      id: 14,
    },
    {
      name: `Mariana van Rooyen`,
      title: "Executive PA",
      img: Mariana,
      id: 15,
    },
    // {
    //   name: "Thabiso Ncane ",
    //   title: "Account Manager",
    //   img: ThabisoImg,
    //   id: 16,
    // },
    {
      name: "Kamogelo Jele",
      title: "Account Manager",
      img: KamogeloImg,
      id: 17,
    },
    {
      name: "Thato Fenyane",
      title: "Intern",
      img: ThatoImg,
      id: 18,
    },
  ]);
  return (
    <div className="row">
      {person.map((person) => (
        <div className=" col-lg-3 col-sm-3 col-md-3">
          {person.img ? (
            <div className="card" style={{ width: "13rem" }}>
              <img src={person.img} class="card-img-top" alt="..." />
            </div>
          ) : (
            <div
              className="card"
              style={{ width: "13rem", height: "13rem" }}
            ></div>
          )}
          {/* <div className="card" style={{ width: "13rem" }}>
            <img src={person.img} class="card-img-top" alt="..." />
          </div> */}
          <div className={classes.name_block}>
            <h4 className={`card-name ${classes.name}`}>{person.name}</h4>
            <p className={`card-text ${classes.title}`}>{person.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
export default Teamcards;
